import { ChangeEventValue, Coords } from 'google-map-react'

import { AssetName, NetworkMarkers } from 'main/util/asset'
import { Priority as MarkerPriority } from './Marker'

export { SchoolListingType as ListingType } from 'main/gql/globalTypes'
export type ExternalPinSource = NetworkMarkers

export const EXTERNAL_NORMAL = AssetName.MARKER
export const EXTERNAL_SELECTED = AssetName.MARKER_SELECTED

export enum CalloutView {
  Fixed = 'fixed',
  Relative = 'relative',
}

export enum PinType {
  Generic = 'generic',
  Wonderschool = 'wonderschool',
}

export interface IGenericPin {
  _type: PinType.Generic
  src?: ExternalPinSource
}

export interface IWonderschoolPin {
  _type: PinType.Wonderschool
  src?: ExternalPinSource
}

export type Pin = IGenericPin | IWonderschoolPin

export interface IMarker {
  callout?: React.ReactNode
  coordinates: Coords
  pin: Pin
  selected: boolean
  priority?: MarkerPriority
  onClick?: () => void
}

export interface ICalloutOffset {
  bottom: number
  left: number
}

export type MapState = ChangeEventValue
